import "core-js/stable"
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import global from './global'

Vue.use(global)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
